import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useToast } from 'context/ToastContext';
import * as apiProduct from 'api/apiProducts';
import AddVendorForm from './AddVendorForm';

interface AddVendorFormikProps {
    onCreated: () => Promise<void>;
}

const AddVendorFormik = ({ onCreated }: AddVendorFormikProps) => {
    const { t } = useTranslation(['Products', 'common']);
    const { showToast } = useToast();

    return (
        <Formik
            initialValues={{ vendorName: '', vendorEmail: '' }}
            onSubmit={async (values, { resetForm, setFieldError }) => {
                const email = String(values.vendorEmail || '').trim();
                const resCreate = await apiProduct.createVendor(values.vendorName, email || null);
                if (resCreate?.stat) {
                    await onCreated();
                    resetForm();
                    showToast(t('vendorsEditor.messCreated'), 'success');
                    return;
                }

                if (resCreate?.errCode === 'DUPLICATE_NAME') {
                    setFieldError('vendorName', t('vendorsEditor.messDuplicate'));
                    return;
                }

                if (resCreate?.errCode === 'EMPTY_NAME') {
                    setFieldError('vendorName', t('vendorsEditor.messEmpty'));
                    return;
                }

                if (resCreate?.errCode === 'INVALID_EMAIL') {
                    setFieldError('vendorEmail', t('vendorsEditor.messInvalidEmail'));
                    return;
                }

                showToast(t('common:messError'), 'danger');
            }}
        >
            {({ handleSubmit, isSubmitting, errors, touched }) => (
                <AddVendorForm
                    handleSubmit={handleSubmit}
                    isSubmitting={isSubmitting}
                    nameError={touched.vendorName && errors.vendorName ? errors.vendorName : ''}
                    emailError={touched.vendorEmail && errors.vendorEmail ? errors.vendorEmail : ''}
                />
            )}
        </Formik>
    );
};

export default AddVendorFormik;
